import { Box, Container, Typography } from '@material-ui/core'
import { ErrorOutline } from '@material-ui/icons'
import { useMemo, useState } from 'react'

import Button from '@/components/button'
import InputText from '@/components/input-text'
import Loading from '@/components/loading'
import { useGetMembers } from '@/hooks/queries/use-get-members'

import InviteModal from './invite-modal'
import { MembersTable } from './members-table'
import { useStyles } from './styles'

const Members = () => {
  const classes = useStyles()
  const [search, setSearch] = useState('')
  const [openInviteModal, setOpenInviteModal] = useState(false)

  const { data, isLoading, isError, isSuccess } = useGetMembers()

  const filteredMembers = useMemo(
    () =>
      data?.filter(
        (user) =>
          user.name.toLowerCase().includes(search.toLowerCase()) ||
          user.email.toLowerCase().includes(search.toLowerCase()),
      ),
    [data, search],
  )

  return (
    <Container className={classes.container}>
      <header>
        <Typography variant='h1'>Membros</Typography>
        <InputText
          label='Buscar membros...'
          id='search'
          type='search'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Button
          aria-label='Convidar membros'
          outlined
          onClick={() => setOpenInviteModal(true)}
        >
          Convidar membros
        </Button>
      </header>

      {isLoading && <Loading />}
      {isError && (
        <Box display='flex' gridGap='0.8rem'>
          <ErrorOutline />
          <Typography> Ocorreu um ao carregar os membros.</Typography>
        </Box>
      )}

      {isSuccess && <MembersTable members={filteredMembers} />}

      <InviteModal
        handleModal={() => setOpenInviteModal(false)}
        open={openInviteModal}
      />
    </Container>
  )
}

export default Members
